import { SocialLink } from "@/ui/SocialLink";
import { TeamMemberImage } from "@/ui/TeamMemberImage";
import cn from "classnames";
import Link from "next/link";
import { Card } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className = "px-3", name, title, linkedin, email, image, href }) {
  return (
    <Card className={cn(className, classes.ConsultantCard)}>
      <Card.Img as={Link} href={href}>
        <TeamMemberImage className="m-0" src={image} alt={name} hoverable={false} />
      </Card.Img>
      <Card.Body as={Link} href={href}>
        <Card.Title as="h5" className="fw-bold mb-2">
          {name}
        </Card.Title>
        <Card.Text as="div">{title}</Card.Text>
        <Card.Footer className="px-0 mt-3">
          {linkedin && <SocialLink href={linkedin} icon="linkedin" />}
          {email && <SocialLink href={`mailto:${email}`} icon="email" />}
        </Card.Footer>
      </Card.Body>
    </Card>
  );
}
